import React from 'react';
import PropTypes from 'prop-types';

import Button from '../elements/Button';

import { Colors, FontSizes } from '../Theme';

const ActionState = ({ button, children, imageUrl, style, title }) => {
  const styles = {
    component: {
      textAlign: 'center',
      padding: '40px 0',
      color: Colors.GRAY.hex
    },
    title: {
      fontSize: FontSizes.XLARGE
    },
    message: {
      fontSize: FontSizes.LARGE,
      color: Colors.GRAY.hex,
      margin: '20px auto 40px',
      width: '90%',
      maxWidth: 600,
      lineHeight: '1.4em'
    }
  };

  return (
    <div style={Object.assign({}, styles.component, style)}>
      <div style={styles.title}>{title}</div>
      <div style={styles.message}>{children}</div>
      {imageUrl && <img alt='Action State' src={imageUrl} style={{ maxWidth: '100%' }} />}
      {button ? <Button {...button} /> : null}
    </div>
  );
};

ActionState.propTypes = {
  button: PropTypes.object,
  imageUrl: PropTypes.string,
  title: PropTypes.string
};

export default ActionState;
